module.exports = __webpack_public_path__ + "img/edit.488bf828.svg";